import React, { Component, createRef } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import TextFieldGroup from "../../components/common/TextFieldGroup";
import TextAreaFieldGroup from "../../components/common/TextAreaFieldGroup";
import { Button, Col, Row } from "reactstrap";
import ContentBox from "../../components/common/ContentBox";
import SmallSpinner from "../../components/common/SmallSpinner";
import { CORE_API_ROOT } from "../../config/api-config";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import qs from "querystring";

class Contact extends Component {
	constructor() {
		super();
		this.state = {
			name: "",
			email: "",
			message: "",
			errors: {},
			working: false,
			captchaToken: null
		};

		this.recaptchaRef = createRef();
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleCaptchaChange = this.handleCaptchaChange.bind(this);
	}

	componentDidMount() {}

	componentWillReceiveProps(nextProps) {}

	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
	}

	// reCAPTCHA handler
	handleCaptchaChange(token) {
		// Store the token; if null, captcha expired or errored
		this.setState({ captchaToken: token });
	}

	onSubmit(e, projectId) {
		e.preventDefault();

		// Prevent submission if captcha token isn't present
		if (!this.state.captchaToken) {
			return;
		}

		this.setState({ errors: {}, working: true });

		const data = {
			name: this.state.name,
			email: this.state.email,
			message: this.state.message,
			projectId: projectId,
			captchaToken: this.state.captchaToken
		};

		axios({
			method: "POST",
			url: `${CORE_API_ROOT}/contact`,
			data: data
		})
			.then(res => {
				alert("Your message has been sent.");
				this.setState({
					working: false,
					name: "",
					email: "",
					message: "",
					errors: {},
					captchaToken: null
				});
				// Reset the captcha after successful submission
				if (this.recaptchaRef.current) {
					this.recaptchaRef.current.reset();
				}
			})
			.catch(res => {
				this.setState({ errors: res.response.data, working: false });
				alert("Error sending message.");
			});
	}

	render() {
		const { errors, captchaToken } = this.state;
		const isButtonDisabled = this.state.working || !captchaToken;
		const params = qs.parse(this.props.location.search.slice(1));
		const projectId = params.projectId;
		const name = params.name;

		return (
			<div style={{ justifyContent:'center', margin: '0 auto', width: '100%', maxWidth: '720px' }}>
				<ContentBox width="6" title={`Contact ${name ? name : ""}`} subtitle={`Send ${name ? name : "us"} an email`}>

					<form noValidate onSubmit={e => this.onSubmit(e, projectId)}>
						<TextFieldGroup
							label="Your Name"
							placeholder=""
							name="name"
							type="text"
							value={this.state.name}
							onChange={this.onChange}
							error={errors.name}
						/>
						<TextFieldGroup
							label="Your Email"
							placeholder=""
							name="email"
							type="email"
							value={this.state.email}
							onChange={this.onChange}
							error={errors.email}
						/>
						<TextAreaFieldGroup
							label="Message"
							placeholder=""
							name="message"
							type="message"
							value={this.state.message}
							onChange={this.onChange}
							error={errors.message}
						/>

						{/* Always render reCAPTCHA with a fallback key */}
						<div className="recaptcha-container" style={{ margin: '20px 0' }}>
							<ReCAPTCHA
								ref={this.recaptchaRef}
								sitekey={this.props.apiKeys.keys.captchaKey}
								onChange={this.handleCaptchaChange}
							/>
						</div>

						<Row className="pt-3">
							<Col xs="6">
								<Button
									disabled={isButtonDisabled}
									color="primary"
									className="px-4"
								>
									<SmallSpinner width="20px" show={this.state.working} />
									Submit
								</Button>
							</Col>
						</Row>

						{/* Helper message that shows when captcha isn't completed */}
						{!captchaToken && (
							<div style={{
								marginTop: '10px',
								fontSize: '0.85rem',
								color: '#666'
							}}>
								Please complete the reCAPTCHA verification to enable submission.
							</div>
						)}
					</form>
				</ContentBox>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	apiKeys: state.settings.apiKeys
});

export default connect(
	mapStateToProps,
	{}
)(withRouter(Contact));
